import { notify } from "@kyvg/vue3-notification";

export const useNotify = () => {
  const success = (text: string) => {
    notify({
      title: "Success!",
      text,
      type: "success",
    });
  };

  const error = (text: string) => {
    notify({
      title: "Error!",
      text,
      type: "error",
    });
  };

  return { success, error };
};
